const Errors = {
  JOIN_BANNED: '10001',
  JOIN_INVALID_CODE: '10002',
};

export default Errors;
